import { render, staticRenderFns } from "./address_box.vue?vue&type=template&id=12f9669c&scoped=true&"
import script from "./address_box.vue?vue&type=script&lang=js&"
export * from "./address_box.vue?vue&type=script&lang=js&"
import style0 from "./address_box.vue?vue&type=style&index=0&id=12f9669c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9669c",
  null
  
)

component.options.__file = "address_box.vue"
export default component.exports